/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';
import { FancyFirebaseObject } from '../base/FancyFirebaseObject';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';
import { FbdbSetting } from 'src/app/app-data/models/FbdbSetting';

export class FbdbSettingsObject extends FancyFirebaseObject<FbdbSetting> {
	constructor(angularLand: AngularLandConnection, path: RefOrObservable) {
		super(angularLand, path);
	}

	public $$updated(child: any) {
		if (!child || !child.payload.exists()) {
			return {};
		}
		return new FbdbSetting(child.payload.val());
	}
}
